const EMPTY_FIELD_VALUE = '-';

export default EMPTY_FIELD_VALUE;
